function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTabbarMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7.969.594C8.109.5 8.25.5 8.437.547L18.703 3.5l6.75-2.719C26.156.5 27 1.016 27 1.812v15.704c0 .468-.281.89-.75 1.03l-7.266 2.907c-.14.094-.28.094-.468.047L8.25 18.547 1.5 21.266A1.1 1.1 0 010 20.234V4.531c0-.468.234-.89.703-1.031L7.97.594zM1.5 19.672l6-2.39V2.374l-6 2.39v14.907zM18 4.859L9 2.281v14.906l9 2.579V4.859zm1.5 14.813l6-2.39V2.374l-6 2.39v14.907z",
    fill: props.fill
  }));
}
export default SvgIconTabbarMap;